"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
var webconfig = require('../../config/web.js');
var pageit_1 = __importDefault(require("./pageit"));
var pagebox;
//加载正文
loadcontent();
//埋点
sendcount();
function loadcontent() {
    getcontent(1).then(function (jsonf) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if ((_a = jsonf === null || jsonf === void 0 ? void 0 : jsonf.data) === null || _a === void 0 ? void 0 : _a.notice_title) {
            var data = (jsonf === null || jsonf === void 0 ? void 0 : jsonf.data) || {};
            $("#notice_content").text((_b = data === null || data === void 0 ? void 0 : data.notice_content) !== null && _b !== void 0 ? _b : "");
            $(".title_text_en").html((_c = data === null || data === void 0 ? void 0 : data.notice_title) !== null && _c !== void 0 ? _c : "");
            (data === null || data === void 0 ? void 0 : data.title_ch) ? $(".title_text_cn").html(data === null || data === void 0 ? void 0 : data.title_ch) : $(".title_text_cn").hide();
            document.title = (data === null || data === void 0 ? void 0 : data.notice_title) + " _ " + (stockInfo === null || stockInfo === void 0 ? void 0 : stockInfo.name) + "(" + (stockInfo === null || stockInfo === void 0 ? void 0 : stockInfo.code) + ") _ \u516C\u544A\u6B63\u6587";
            // if (data.attach_url_web) {
            //     $(".pdf-link").attr("href", data.attach_url_web)
            // }
            // else {
            //     $(".pdf-link").hide()
            // }
            $("#ggdate").text(fieldtools_1["default"].dateformat(data === null || data === void 0 ? void 0 : data.notice_date, "YYYY年MM月DD日"));
            // 循环展示附件内容
            var atlist = (_d = data === null || data === void 0 ? void 0 : data.attach_list) !== null && _d !== void 0 ? _d : [];
            var show_arr_1 = atlist.filter(function (v) { return ["0", "1", "2", "3", "4", "5", "6"].indexOf(v === null || v === void 0 ? void 0 : v.attach_type) > -1; });
            if (show_arr_1 && show_arr_1.length > 0) {
                $('.pdfNum').text('该公告有' + show_arr_1.length + '份附件');
                // 循环展示
                var pdf_html = '';
                var _loop_1 = function (i) {
                    pdf_html += "<div>\n                            <a href=\"" + (((_e = show_arr_1[i]) === null || _e === void 0 ? void 0 : _e.attach_url) ? (_f = show_arr_1[i]) === null || _f === void 0 ? void 0 : _f.attach_url : '') + "\">\n                                <i class=\"icon icon_pdf valign-middle\"></i>\n                                \u539F\u7248\u9644\u4EF6(" + (((_g = show_arr_1[i]) === null || _g === void 0 ? void 0 : _g.attach_size) ? (_h = show_arr_1[i]) === null || _h === void 0 ? void 0 : _h.attach_size : '-') + "KB)\n                            </a>\n                        ";
                    var list_en = (_k = (_j = data === null || data === void 0 ? void 0 : data.attach_list_ch) === null || _j === void 0 ? void 0 : _j.filter(function (v) { var _a; return (v === null || v === void 0 ? void 0 : v.seq) == ((_a = show_arr_1 === null || show_arr_1 === void 0 ? void 0 : show_arr_1[i]) === null || _a === void 0 ? void 0 : _a.seq); })) === null || _k === void 0 ? void 0 : _k[0];
                    if (list_en === null || list_en === void 0 ? void 0 : list_en.attach_size) {
                        pdf_html += "<a href=\"" + ((list_en === null || list_en === void 0 ? void 0 : list_en.attach_url) ? list_en === null || list_en === void 0 ? void 0 : list_en.attach_url : '') + "\">\n                                <i class=\"icon icon_pdf valign-middle\"></i>\n                                \u4E2D\u6587\u7FFB\u8BD1\u7248(" + ((list_en === null || list_en === void 0 ? void 0 : list_en.attach_size) ? list_en === null || list_en === void 0 ? void 0 : list_en.attach_size : '-') + "KB)\n                            </a>";
                    }
                    pdf_html += "</div>";
                };
                for (var i = 0; i < show_arr_1.length; i++) {
                    _loop_1(i);
                }
                $('.context_pdf').html(pdf_html);
            }
            pagebox = new pageit_1["default"]({
                page: 1,
                pages: data.page_size,
                go: function (p) {
                    getcontent(p).then(function (json) {
                        var _a, _b;
                        window.scroll(0, 0);
                        $("#notice_content").text(((_a = json === null || json === void 0 ? void 0 : json.data) === null || _a === void 0 ? void 0 : _a.notice_content) || "");
                        pagebox.set({ page: p, pages: (_b = json === null || json === void 0 ? void 0 : json.data) === null || _b === void 0 ? void 0 : _b.page_size });
                    });
                }
            });
        }
        else {
        }
    });
}
function getcontent(p) {
    return $.ajax({
        url: webconfig.getWebPath("cnoticeurl") + "api/content/ann",
        type: "GET",
        dataType: "jsonp",
        jsonp: "cb",
        data: {
            art_code: stockInfo.infocode,
            client_source: 'web',
            page_index: p
        },
    });
}
function sendcount() {
    var t = document.createElement("img");
    t.src = "//np-metadata.eastmoney.com/api/metadata.jpg?event=1&source=3&mode=2&type=2&id=" + stockInfo.infocode,
        t.style.display = "none",
        document.body.appendChild(t),
        setTimeout(function () {
            document.body.removeChild(t);
        }, 2e3);
}
